import Abstract from '../../framework/Abstract';
import CountUp from '../../framework/CountUp';

import './B14-facts.scss';

class B14Facts extends Abstract {
	init() {
		const { interval, countSpeed, startFrom } = this.props;
		const targetCounters = this.root.querySelectorAll('.B14-facts__counter');
		const intervalSpeed = interval || 25;
		const countUpSpeed = countSpeed || 1500;
		const startFromPercentage = startFrom || 0;

		// Speeed was slowed down per design and client request
		if (targetCounters) {
			this.countUp = new CountUp({
				counters: targetCounters,
				intervalSpeed,
				countUpSpeed,
				startFromPercentage,
			});

			this.countUp.countUpWhenInView();
		}
	}
}

export default B14Facts;
